<div class="bg-white pt-3">
    <div class="col-sm-9"><h5 i18n>Bulk Updates Performed</h5></div>
    <div class="row">
        <div class="col-sm-9" i18n>List of all Bulk Updates performed for this dealer.</div>
    </div>

    <mat-table class="table-responsive table compact table-bidit table-hover" [dataSource]="dataSource"
               matSort matSortActive="projectName" matSortDirection="asc">
        <ng-container matColumnDef="criteria">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Bulk Change Criteria</mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                <span *ngIf="bulkUpdate.filterCriteria.searchText != null">{{bulkUpdate.filterCriteria.searchText}}<br /></span>
                <span *ngIf="bulkUpdate.filterCriteria.rValueDesc != null">{{bulkUpdate.filterCriteria.rValueDesc}}<br /></span>
                <span *ngIf="bulkUpdate.filterCriteria.itemTypeDesc != null">{{bulkUpdate.filterCriteria.itemTypeDesc}} <br /></span>
                <span *ngIf="bulkUpdate.filterCriteria.statusDesc != null">{{bulkUpdate.filterCriteria.statusDesc}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="details">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Items Updated</mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                {{bulkUpdate.details.length}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bulkChangeType_Desc">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Adjustment Type</mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                {{bulkUpdate.bulkChangeType?.bulkChangeType_Desc}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bulkChange_AdjustmentAmount">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Adjustment Value</mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                {{bulkUpdate.bulkChange_AdjustmentAmount | number:'1.5-5' }}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bulkChange_Created">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Changed Date</mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                {{bulkUpdate.bulkChange_Created | date:'short'}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="changedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Changed By</mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                {{bulkUpdate.createdBy?.firstName}} {{bulkUpdate.createdBy?.lastName}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
            <mat-cell *matCellDef="let bulkUpdate">
                <button type="button" (click)="rollbackPriceChange(bulkUpdate.bulkChange_ID)" class="float-right btn btn-bidit-action" i18n>Revert</button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <mat-paginator [length]="bulkUpdates?.length" [pageSize]="10" [pageSizeOptions]="[10]"></mat-paginator>
    <div class="mat-dialog-actions float-right">
        <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Done</a>
    </div>
</div>
